import type { UscVehicleActionsType } from "../actions/UscVehicleActions";
import {
    USC_VEHICLE_FETCH_FAILED,
    USC_VEHICLE_INIT,
    USC_VEHICLE_SET_AGGREGATED_COUNT,
    USC_VEHICLE_SET_ID,
    USC_VEHICLE_SET_PRICE,
    USC_VEHICLE_SET_REQUIRE_FETCH,
    USC_VEHICLE_SET_TYPE,
} from "../actions/UscVehicleActions";
import type { VehicleType } from "../../../shared-logic/types/UscCommonTypes";
import { UscContext } from "../../../shared-logic/types/UscCommonTypes";

export type UscVehicleReducerType = {
    fetchClientSide: boolean; // If true this means frontend should try to fetch the vehicle.
    fetchFailed: boolean;
    type: UscContext;
    result: VehicleType | null;
    source: unknown | null; // for debugging purposes only, filled when query.loadVehicleSourceData is true
    // vehicleForSaleId is also present in result but in cases where the result needs to be fetched it is useful to already have the id for other logic.
    vehicleForSaleId: string;
};

export const initialStateUscVehicle: UscVehicleReducerType = {
    type: UscContext.Used,
    fetchClientSide: false,
    fetchFailed: false,
    result: null,
    source: null,
    vehicleForSaleId: "",
};

const UscVehicleReducer = (
    state: UscVehicleReducerType = initialStateUscVehicle,
    action: UscVehicleActionsType,
): UscVehicleReducerType => {
    switch (action.type) {
        case USC_VEHICLE_INIT: {
            return {
                ...state,
                result: action.result,
                source: action.source,
                vehicleForSaleId: action.result?.id || state.vehicleForSaleId,
            };
        }

        case USC_VEHICLE_SET_TYPE: {
            return { ...state, type: action.vehicleType };
        }

        case USC_VEHICLE_SET_REQUIRE_FETCH: {
            return { ...state, fetchClientSide: action.requireFetch };
        }

        case USC_VEHICLE_FETCH_FAILED: {
            return { ...state, fetchFailed: action.failed };
        }

        case USC_VEHICLE_SET_ID: {
            return { ...state, vehicleForSaleId: action.id };
        }

        case USC_VEHICLE_SET_PRICE: {
            return {
                ...state,
                result: state.result
                    ? {
                          ...state.result,
                          price: action.price,
                      }
                    : null,
            };
        }

        case USC_VEHICLE_SET_AGGREGATED_COUNT: {
            return {
                ...state,
                result: state.result
                    ? {
                          ...state.result,
                          vehicleCount: action.count,
                      }
                    : null,
            };
        }

        default:
            return state;
    }
};

export default UscVehicleReducer;
